const strUpperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const strLowerCase = 'abcdefghijklmnopqrstuvwxyz';
const strNumber = '0123456789';
const strCharacters = '!@#$%^&*?_~';

// Checks a string for a list of characters
function countContain(strPassword: string, strCheck: string) {
  let nCount = 0;

  for (let i = 0; i < strPassword.length; i++) {
    if (strCheck.indexOf(strPassword.charAt(i)) > -1) {
      nCount++;
    }
  }

  return nCount;
}

export default function checkPassword(strPassword: string) {
  // Reset combination count
  let nScore = 0;

  // Password length
  // -- Less than 4 characters
  if (strPassword.length < 5) {
    nScore += 2;
  }
  // -- Less than 8
  else if (strPassword.length < 8) {
    nScore += 5;
  }
  // -- 8 or more
  else if (strPassword.length > 7) {
    nScore += 10;
  }

  // Letters
  const nUpperCount = countContain(strPassword, strUpperCase);
  const nLowerCount = countContain(strPassword, strLowerCase);
  const nLowerUpperCount = nUpperCount + nLowerCount;
  // -- Letters are all lower case
  if (nUpperCount == 0 && nLowerCount != 0) {
    nScore += 10;
  }
  // -- Letters are upper case and lower case
  else if (nUpperCount != 0 && nLowerCount != 0) {
    nScore += 20;
  }

  // Numbers
  const nNumberCount = countContain(strPassword, strNumber);
  // -- 1 number
  if (nNumberCount == 1) {
    nScore += 10;
  }
  // -- 3 or more numbers
  if (nNumberCount >= 3) {
    nScore += 20;
  }

  // Characters
  const nCharacterCount = countContain(strPassword, strCharacters);
  // -- 1 character
  if (nCharacterCount == 1) {
    nScore += 10;
  }
  // -- More than 1 character
  if (nCharacterCount > 1) {
    nScore += 25;
  }

  // -- Letters and numbers
  if (nNumberCount != 0 && nLowerUpperCount != 0) {
    nScore += 2;
  }
  // -- Letters, numbers, and characters
  if (nNumberCount != 0 && nLowerUpperCount != 0 && nCharacterCount != 0) {
    nScore += 3;
  }
  // -- Mixed case letters, numbers, and characters
  if (nNumberCount != 0 && nUpperCount != 0 && nLowerCount != 0 && nCharacterCount != 0) {
    nScore += 5;
  }

  return nScore;
}
